import { useLocation } from "react-router-dom";

export const WithQueryParam = ({ children }) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const hibisId = params.get("sc_customer");
  const scAnswer = params.get("sc_answer");

  return children({ hibisId, scAnswer });
};
